import React, { useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';

const ScrollToTopRoute = (props) => {
	const { pathname } = useLocation();
	const { component: AppComponent, ...rest } = props;

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return (
		<div>
			<Route {...rest} component={AppComponent} />
		</div>
	);
};

export default ScrollToTopRoute;
